import { render, staticRenderFns } from "./Searchquery.vue?vue&type=template&id=1f8f9b0c&scoped=true"
import script from "./Searchquery.vue?vue&type=script&lang=js"
export * from "./Searchquery.vue?vue&type=script&lang=js"
import style0 from "./Searchquery.vue?vue&type=style&index=0&id=1f8f9b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f9b0c",
  null
  
)

export default component.exports